export const team = {
  name: "Buchtel Griffins Baseball Program",
  city: "Akron, OH",
  season: 2026,
  mission:
    "Giving kids from our community the chance to compete, grow, and dream.",
  goal: 5000,
  raised: 1410,
  // Goal categories are now managed in the coach portal (goal_categories table)
};

export const players = [
  { id: 1, name: "Jaxson", number: 12, goal: 500, raised: 375 },
  { id: 2, name: "Jordan", number: 7, goal: 500, raised: 250 },
  { id: 3, name: "Michah", number: 3, goal: 500, raised: 100 },
  { id: 4, name: "Steve", number: 24, goal: 500, raised: 310 },
  { id: 5, name: "D2", number: 9, goal: 500, raised: 200 },
  { id: 6, name: "Isaiah", number: 1, goal: 500, raised: 175 },
];

export const donors = [
  { id: 1, name: "Coach Williams", amount: 100, playerId: 1, message: "Proud of you, Jaxson! Let's have a great season.", date: "2026-02-15", anonymous: false },
  { id: 2, name: "Anonymous", amount: 50, playerId: 2, message: "", date: "2026-02-18", anonymous: true },
  { id: 3, name: "Grandma Rose", amount: 75, playerId: 1, message: "Hit a home run for me!", date: "2026-02-20", anonymous: false },
  { id: 4, name: "Mike Thompson", amount: 25, playerId: 3, message: "Go Griffins!", date: "2026-03-01", anonymous: false },
  { id: 5, name: "Sarah Chen", amount: 200, playerId: 4, message: "Happy to support youth baseball in Akron.", date: "2026-03-03", anonymous: false },
  { id: 6, name: "Anonymous", amount: 50, playerId: 5, message: "Keep swinging!", date: "2026-03-05", anonymous: true },
  { id: 7, name: "Uncle Jerome", amount: 100, playerId: 6, message: "Isaiah, make us proud out there!", date: "2026-03-08", anonymous: false },
  { id: 8, name: "Akron Community Fund", amount: 500, playerId: null, message: "Investing in our youth, one season at a time.", date: "2026-03-10", anonymous: false },
];
